/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dataStates.vue?vue&type=template&id=175c205e&scoped=true"
import script from "./dataStates.vue?vue&type=script&lang=js"
export * from "./dataStates.vue?vue&type=script&lang=js"
import style0 from "./dataStates.vue?vue&type=style&index=0&id=175c205e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175c205e",
  null
  
)

export default component.exports